import {
  BreakpointsPx,
  ImpHidden,
  ImpSpacer,
} from '@imprint-payments/imprint-ui';
import { useEffect } from 'react';

import { useImpState } from '../../app/hooks';
import Application from '../../components/application/Application';
import { HeaderHandler } from '../../components/HeaderHandler/HeaderHandler';
import useNextPage from '../../hooks/nextPage';
import { COOKIEKEY } from '../../utils/cookieConstants';
import { getCookieValueFor } from '../../utils/functionUtils';
import { isSDK } from '../../utils/sdk';
import { handleRedirectedFromServicing } from './ApplicationHomeUtils';

export default function ApplicationHome() {
  const nextPage = useNextPage();
  const { screenState, dispatch } = useImpState();

  useEffect(() => {
    nextPage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [screenState.screen]);

  useEffect(() => {
    if (getCookieValueFor(COOKIEKEY.REAPPLICATION) === 'true') {
      dispatch(handleRedirectedFromServicing());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div style={{ height: '100dvh', display: 'flex', flexDirection: 'column' }}>
      <HeaderHandler showRewardsButton />
      <ImpHidden hideBelow={BreakpointsPx.Application}>
        <ImpSpacer height={isSDK() ? 'xl' : '3xl'} />
      </ImpHidden>
      <Application />
    </div>
  );
}
